import { GoogleTrackingConfig } from '@arianee/arn-types';
import { ArnPageViewEvent } from '../ArnPageViewEvent';
import { ArnTrackedEvent } from '../ArnTrackedEvent';
import { ArnCtaEvent } from '../ArnCtaEvent';

export class GoogleAnalyticsService {
  constructor(protected config: GoogleTrackingConfig) {}

  report(event: ArnTrackedEvent) {
    this.config.gtag('event', event.name, {
      eventCategory: event.category,
      eventLabel: event.label,
      eventAction: event.action,
      eventValue: event.value,
    });
  }

  pageViewed(pageViewEvent?: ArnPageViewEvent) {
    this.config.gtag('event', 'page_view', {
      page_title: pageViewEvent?.title,
      page_location: pageViewEvent?.location,
      page_path: pageViewEvent?.path,
    });
  }

  ctaClicked(ctaEvent: ArnCtaEvent): void {
    this.config.gtag('event', 'cta_click', ctaEvent);
  }
}
